import { render, staticRenderFns } from "./PsPatientPhysicalActivity.vue?vue&type=template&id=5934b7be&scoped=true&"
import script from "./PsPatientPhysicalActivity.vue?vue&type=script&lang=js&"
export * from "./PsPatientPhysicalActivity.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientPhysicalActivity.vue?vue&type=style&index=0&id=5934b7be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934b7be",
  null
  
)

export default component.exports